import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";
import { motion } from "framer-motion";

function AboutCard() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <Card
        className="quote-card-view"
        style={{
          background: "transparent",
          border: "none",
        }}
      >
        <Card.Body>
          <blockquote className="blockquote mb-0">

            {/* Introduction */}
            <p
              style={{
                textAlign: "justify",
                lineHeight: "1.7",
                marginBottom: "10px",
              }}
            >
              Hi, I'm{" "}
              <span className="purple">
                <strong>Gaurav Kumar</strong>
              </span>{" "}
              from{" "}
              <span className="purple">
                <strong>Patna, India</strong>
              </span>
              , currently pursuing a B.Tech in Computer Science Engineering
              at <span className="purple">Lovely Professional University</span>.
            </p>

            {/* Professional Summary */}
            <p
              style={{
                textAlign: "justify",
                lineHeight: "1.7",
                marginBottom: "10px",
              }}
            >
              I am a passionate{" "}
              <span className="purple">
                <strong>Full Stack Software Engineer</strong>
              </span>{" "}
              with strong interest in building scalable, secure, and
              enterprise-grade applications using modern technologies such as{" "}
              <span className="purple">
                <strong>
                  ASP.NET Core, React.js, Microservices, Redis,
                  RabbitMQ, SQL Server, Docker, and Cloud technologies.
                </strong>
              </span>
            </p>

            {/* Career Goal */}
            <p
              style={{
                textAlign: "justify",
                lineHeight: "1.7",
                marginBottom: "15px",
              }}
            >
              My long-term objective is to become a highly skilled{" "}
              <span className="purple">
                <strong>
                  Software Architect and Full Stack Engineer
                </strong>
              </span>
              , specializing in distributed systems, cloud-native
              applications, and high-performance enterprise software.
            </p>

            {/* Hobbies */}
            <p
              style={{
                marginBottom: "12px",
                fontWeight: "600",
              }}
            >
              🚀 Beyond software engineering, I enjoy:
            </p>

            <ul style={{ marginBottom: "20px" }}>
              <motion.li
                className="about-activity"
                whileHover={{
                  scale: 1.05,
                  color: "#c770f0",
                }}
              >
                <ImPointRight /> 🏏 Playing Cricket
              </motion.li>

              <motion.li
                className="about-activity"
                whileHover={{
                  scale: 1.05,
                  color: "#c770f0",
                }}
              >
                <ImPointRight /> 🎬 Watching Movies
              </motion.li>

              <motion.li
                className="about-activity"
                whileHover={{
                  scale: 1.05,
                  color: "#c770f0",
                }}
              >
                <ImPointRight /> ✈️ Travelling & Exploring
              </motion.li>
            </ul>

            {/* Quote */}
            <p
              style={{
                color: "rgb(155,126,172)",
                fontStyle: "italic",
                marginBottom: "8px",
              }}
            >
              "Great software is not just about writing code;
              it's about creating scalable solutions that solve
              real-world problems."
            </p>

            <footer className="blockquote-footer">
              Gaurav Kumar
            </footer>

          </blockquote>
        </Card.Body>
      </Card>
    </motion.div>
  );
}

export default AboutCard;